import { Component } from '@angular/core';
import { CardKpiMapComponent } from 'app/components/card-kpi-map/card-kpi-map.component';

@Component({
  selector: 'app-page-kpi-map',
  imports: [CardKpiMapComponent],
  templateUrl: './page-kpi-map.component.html',
  styleUrl: './page-kpi-map.component.scss',
})
export class PageKpiMapComponent {}
